package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class FinancingEntity(
  public val id: String,
  public val name: String,
  public val creditorName: String?,
  public val purpose: String?,
  public val installmentAmountCents: Long,
  public val commissionCents: Long,
  public val extraInstallmentCents: Long?,
  public val extraInstallmentMonth: Long?,
  public val totalAmountCents: Long,
  public val remainingAmountCents: Long,
  public val accountId: String?,
  public val categoryId: String?,
  public val startEpochDay: Long,
  public val endEpochDay: Long,
  public val autoGenerateOnReminder: Boolean,
  public val isClosed: Boolean,
  public val isDeleted: Boolean,
  public val logoEmoji: String?,
  public val logoUri: String?,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
